import { cloneElement } from "react";

import { Box, BoxProps, Text } from "@vinomofo/components";

export interface WineNerdBadgeProps extends BoxProps {
  icon: JSX.Element;
  heading: string;
  label: string;
}

export const WineNerdBadge = ({
  icon,
  heading,
  label,
  ...rest
}: WineNerdBadgeProps): JSX.Element => {
  return (
    <Box
      display="flex"
      justifyContent="flex-start"
      alignItems={["center", "flex-start"]}
      {...rest}
    >
      <Box marginRight="15px" alignSelf="baseline">
        <Box
          width={["28px", "28px", "48px"]}
          height={["28px", "28px", "48px"]}
          color="brand"
        >
          {cloneElement(icon, { size: "100%" })}
        </Box>
      </Box>
      <Box
        display="flex"
        flexDirection={["row", "column"]}
        justifyContent="center"
        alignItems="flex-start"
      >
        <Box
          marginBottom="3px"
          minWidth={["40vw", "auto"]}
          paddingRight="5px"
          paddingTop="4px"
        >
          <Text
            fontFamily="heading"
            color="darkMofo"
            fontSize={["16px", "16px", "20px"]}
            letterSpacing="normal"
            fontWeight={600}
            lineHeight={1.2}
          >
            {heading}
          </Text>
        </Box>
        <Box paddingTop={["4px", 0]}>
          <Text
            color="text.normal"
            fontSize={2}
            letterSpacing="normal"
            lineHeight="1"
          >
            {label}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
